import { notify } from "@kyvg/vue3-notification";

type NotificationPayload = {
  type: string;
  text: string;
};

export const notifyUser = ({ type, text }: NotificationPayload) => {
  notify({
    type,
    text,
    duration: type === "success" ? 3000 : -1, // -1 means infinite
  });
};
